import React, { useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import useNebula from 'hooks/useNebula';
// import useQlikApp from 'hooks/useQlikApp';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import AppContext from '../../AppContext';
import languagify from '../../../utils/languagify';

const useStyles = makeStyles((theme) => ({
  viz: {
    height: 450,
    width: '100%',
    '& > div': {
      backgroundColor: 'transparent',
      overflow: 'visible !important',
    },
    '& svg': {
      overflow: 'visible !important',
    },
    '& circle': {
      cursor: 'pointer !important',
    },
    '& text': {
      color: 'red !important',
      cursor: 'pointer !important',
    },
    '& img': {
      cursor: 'pointer !important',
    },
    '& [data-key="y-axis"]': {
      '& text': {
        cursor: 'default !important',
      },
    },
    '& [data-key="x-axis"]': {
      '& text': {
        cursor: 'default !important',
      },
    },
  },
  bubbleVizWrapper: {
    position: 'relative',
  },
  xAxisLabel: {
    position: 'absolute',
    bottom: -15,
    left: ({ lang }) => (lang === 'French' ? 'calc(50% - 200px)' : 'calc(50% - 90px)'),
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  yAxisLabel: {
    position: 'absolute',
    transform: 'rotate(-90deg)',
    left: -3,
    top: ({ lang }) => (lang === 'French' ? 'calc(50% + 165px)' : 'calc(50% + 100px)'),
    fontFamily: 'Source Sans Pro, sans-serif',
    transformOrigin: 'left',
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
}));

const Bubble = ({ mixby }) => {
  const nebula = useNebula();
  const elementRef = useRef();
  const vizRef = useRef();
  // const app = useQlikApp();

  const { qlikApp } = useContext(AppContext);

  const { lang } = useContext(AppContext);

  useEffect(async () => {
    if (!nebula) return;
    // Sum([Total Employees - 2022]-[White Total - 2022])/sum([Total Employees - 2022])
    vizRef.current = await nebula.render({
      element: elementRef.current,
      type: 'bubble2022',
      fields: [
        {
          qDef: {
            qFieldDefs: ['Name of media outlet for search - 2022'],
          },
        },
        // Outlet name short
        {
          qDef: {
            qFieldDefs: ['Name of media outlet completing the survey - 2022'],
          },
        },
        {
          qDef: {
            qDef: '=Only({<[Results - 2022]={"Disaggregate"}, [Name of media outlet for search - 2022]=>} ([Total Employees Excl Unknown - 2022] - [White Total - 2022]) / [Total Employees Excl Unknown - 2022])',
            qNumFormat: {
              qType: 'I',
              qnDec: 3,
              qUseThou: 1,
              qFmt: '###%',
              qDec: '',
            },
          },
        },
        {
          qDef: {
            qDef: '=1-(Only({<[Results - 2022]={"Disaggregate"}, [Name of media outlet for search - 2022]=>} [Supervisor White Total - 2022] / [Supervisor Total Excl Unknown - 2022]))',
            qNumFormat: {
              qType: 'I',
              qnDec: 3,
              qUseThou: 1,
              qFmt: '###%',
              qDec: '',
            },
          },
        },
        {
          qDef: {
            qDef: '=Sum({<[Results - 2022]={"Disaggregate"}, [Name of media outlet for search - 2022]=>}[Total Employees Excl Unknown - 2022])',
          },
        },
      ],
    });
  }, [nebula]);

  // Change based on selects
  useEffect(async () => {
    if (!qlikApp) return;
    const appObj = await qlikApp.getObject(vizRef.current.id);

    await appObj.applyPatches([
      {
        qPath: '/qHyperCubeDef/qMeasures/0/qDef/qDef',
        qOp: 'replace',
        qValue: JSON.stringify(`=Only({<[Results - 2022]={"Disaggregate"}, [Name of media outlet for search - 2022]=>} (${mixby === 'race' ? '[Total Employees Excl Unknown - 2022] - [White Total - 2022]' : '[Women Total - 2022]'}) / ${mixby === 'race' ? '[Total Employees Excl Unknown - 2022]' : '[Total Employees - 2022]'})`),
      },
      {
        qPath: '/qHyperCubeDef/qMeasures/1/qDef/qDef',
        qOp: 'replace',
        qValue: JSON.stringify(`${mixby === 'race' ? '=1-(Only({<[Results - 2022]={"Disaggregate"}, [Name of media outlet for search - 2022]=>} [Supervisor White Total - 2022] / [Supervisor Total Excl Unknown - 2022]))'
          : '=Only({<[Results - 2022]={"Disaggregate"}, [Name of media outlet for search - 2022]=>} [Supervisor Women Total - 2022] / [Supervisor Total - 2022])'}`),
      },
    ], true);
  }, [mixby]);

  const classes = useStyles({ lang });
  return (
    <Box className={classes.bubbleVizWrapper}>
      <Typography variant="body2" className={classes.yAxisLabel}>{mixby === 'race' ? languagify('SUPERVISORS. More Vis. Min. and/or Indig. ⟶') : languagify('SUPERVISORS. More Women ⟶')}</Typography>
      <Typography variant="body2" className={classes.xAxisLabel}>{mixby === 'race' ? languagify('STAFF MEMBERS. More Vis. Min. and/or Indig. ⟶') : languagify('STAFF MEMBERS. More Women ⟶') }</Typography>
      <div id="bubbleViz" className={classes.viz} ref={elementRef} />
    </Box>
  );
};

Bubble.propTypes = {
  mixby: PropTypes.string,
};
Bubble.defaultProps = {
  mixby: 'race',
};

export default Bubble;
